import { BASE_API_URL } from './index';

export const onboardingUpdateCompanyEndpoint = `${BASE_API_URL}/onboarding/company/`;
export const onboardingUpdateCompanyTypeEndpoint = `${BASE_API_URL}/onboarding/company_type/`;
export const onboardingUpdateMembershipEndpoint = `${BASE_API_URL}/onboarding/membership/`;
